/* eslint-disable @typescript-eslint/no-unused-vars */
import { useFormContext } from "components/Form";
import { useStepperContext } from "components/Steps";
import { useEffect, useMemo, useState } from "react";
import {
  ResultResponse,
  simulatorCreditService,
} from "services/simulatorCreditService";
import { SimulateCreditData } from "..";
import { formatValueCurrency } from "utils/formatValueCurrency";
import { DetailsResultPrice } from "./Result";

export function ResultCredit() {
  const [result, setResult] = useState<ResultResponse | undefined>(undefined);

  const {
    methodsForm: { getValues },
    validateFields,
  } = useFormContext();

  const { goToPreviousStep } = useStepperContext();

  useEffect(() => {
    const values = getValues();

    const data = {
      city: values.city.value,
      deadline: values.deadline.value?.replace("meses", "").trim(),
      approximateAmount: formatValueCurrency(values.propertyAmount),
      countMonths: values.countMonths,
      cpf: values.cpf,
      dateBirthday: values.dateBirthday,
      email: values.email,
      financingAmount: formatValueCurrency(values.creditAmount),
      name: values.name,
      phoneNumber: values.phoneNumber,
      propertyType: values.propertyType,
    } as SimulateCreditData;

    const response = simulatorCreditService.simulate(data);

    response.then(({ data }) => {
      setResult(data.data);
    });
  }, [getValues]);

  const creditAmountFormated = useMemo(() => {
    const value = getValues("creditAmount");

    return new Intl.NumberFormat("pt-br", {
      style: "currency",
      currency: "BRL",
    }).format(Number(value / 100));
  }, [getValues]);

  const propertyAmountFormated = useMemo(() => {
    const value = getValues("propertyAmount");

    return new Intl.NumberFormat("pt-br", {
      style: "currency",
      currency: "BRL",
    }).format(Number(value / 100));
  }, [getValues]);

  return (
    <DetailsResultPrice
      result={result}
      creditAmountFormated={creditAmountFormated}
      propertyAmountFormated={propertyAmountFormated}
      showInterestRate={false}
    />
  );
}
